/*
    Author: draplater
    Create Time: 17-8-13
    Project: verbnet2017
*/
import {FrameMeta, FrameInfo} from "./problem-domain/frame";
import {baseDir} from "./utils";
import {Verb} from "./problem-domain/verb";
import {store, waitVersion} from "./reduxSetting";

export interface ProgramIndex {
    frames: FrameMeta[],
    version: number,
    tagVersion: string
}

export namespace VersionWire {
    export async function get (): Promise<string> {
        const versionPromise = fetch(baseDir + "tag/version" + "?t=" + Math.floor(Date.now() / 1000));
        const versionResp = await versionPromise;
        return await versionResp.text();
    }
}

export namespace ProgramIndexWire {
    export async function get (): Promise<ProgramIndex> {
        const infoPromise = fetch(baseDir + "tag/info.json" + "?v=" + await waitVersion);
        const infoResp = await infoPromise;
        const jsonObj = await infoResp.json();
        const ret = jsonObj as ProgramIndex;
        ret.frames = ret.frames.map(x => FrameMeta.fromJSON(x));
        return ret;
    }
}

export namespace FrameInfoWire {
    export async function get (path: string[], defFile: string): Promise<FrameInfo> {
        const url = baseDir + "tag/" + path.join("/") + "/" + defFile;
        const frameResp = await fetch(url + "?v=" + await waitVersion);
        const frameDefContent = await frameResp.text();
        return FrameInfo.fromTxtFormat(frameDefContent);
    }
}

export namespace VerbWire {
    export async function get(path: string[]): Promise<Verb> {
        const lexiconName = path.slice(-1)[0];
        const lexiconUrl = baseDir + "tag/" + path.join("/") + ".tag";
        const lexiconFetch = await fetch(lexiconUrl + "?v=" + await waitVersion);
        const lexiconContent = await lexiconFetch.text();
        return Verb.fromTAGFile(lexiconName, lexiconContent)
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/bridge.ts